var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Today"},[_vm._v(" Today - сегодня ")])}
var staticRenderFns = []

export { render, staticRenderFns }